import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useAccentColor } from "Giving/ManageMyGivingPage/stateHooks";

import FnrButton from "UI/FnrButton3";

import "./NoGiftsContainerQueries.scss";

ListIsEmpty.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.object,
  showButton: PropTypes.bool,
  linkTo: PropTypes.string,
  buttonText: PropTypes.string,
  messageIfNoButton: PropTypes.string,
};

export default function ListIsEmpty({
  title,
  icon,
  showButton,
  linkTo,
  buttonText,
  messageIfNoButton,
}) {
  const accentColor = useAccentColor();

  return (
    <NoGiftsWrapper className="no_gifts_wrapper">
      <Inside className="inside">
        <Icon className="icon">{icon}</Icon>
        <Text className="text">{title}</Text>
        <ButtonWrapper className="button_wrapper">
          {showButton ? (
            <a href={linkTo} target="_blank" rel="noreferrer">
              <FnrButton text={buttonText} color={accentColor} />
            </a>
          ) : (
            <NoButtonMsg>{messageIfNoButton}</NoButtonMsg>
          )}
        </ButtonWrapper>
      </Inside>
    </NoGiftsWrapper>
  );
}

const NoGiftsWrapper = styled.div`
  font-size: 22px;
`;
const Inside = styled.div`
  padding: 40px 20px;

  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: 40px auto;
  grid-template-rows: auto 1fr;
  gap: 10px 20px;
`;
const Icon = styled.div`
  font-size: 40px;
  grid-area: 1 / 1 / 3 / 2;
  align-self: center;
  /* @container wrapper (max-width:450px) {
    grid-area: 1 / 1 / 2 / 2;
  } */
`;
const Text = styled.div`
  grid-area: 1 / 2 / 2 / 3;
`;
const ButtonWrapper = styled.div`
  grid-area: 2 / 2 / 3 / 3;
  /* @container wrapper (max-width:450px) {
    grid-area: 2 / 1 / 3 / 3;
    display: flex;
    justify-content: center;
  } */
`;

const NoButtonMsg = styled.div`
  font-size: 15px;
  opacity: 0.8;
`;
